import React from "react";
import { FloatingLabel, Form, InputGroup, Modal } from "react-bootstrap";
import { Asterisk, Eye, EyeSlash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { ChangePasswordModalProps } from "./ChangePasswordModal.types.tsx";

import { GreenLabel, HeaderLabel, SubHeaderLabel } from "../../components/Labels.tsx";
import { ActionButton, ShowPasswordButton } from "../../components/Buttons.tsx";

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  show,
  close,
  data,
  validated,
  showPassword,
  showConfirmPassword,
  onChange,
  onSubmit,
  onTogglePassword,
  onToggleConfirmPassword,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={close} centered backdrop="static" keyboard={false}>
      <Modal.Body>
        <div className="d-flex justify-content-center mb-2">
          <Asterisk />
          <Asterisk />
          <Asterisk />
        </div>

        <HeaderLabel>{t("changePasswordModal.title")}</HeaderLabel>
        <SubHeaderLabel>{t("changePasswordModal.subtitle")}</SubHeaderLabel>

        <Form noValidate validated={validated} onSubmit={onSubmit}>
          <InputGroup className="mb-3">
            <FloatingLabel label={t("changePasswordModal.passwordLabel")}>
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                value={data.password}
                onChange={onChange}
                required
                minLength={6}
                placeholder=""
              />
              <Form.Control.Feedback type="invalid">
                {t("changePasswordModal.passwordInvalid")}
              </Form.Control.Feedback>
            </FloatingLabel>

            <ShowPasswordButton onClick={onTogglePassword}>
              {showPassword ? <EyeSlash /> : <Eye />}
            </ShowPasswordButton>
          </InputGroup>

          <InputGroup className="mb-3">
            <FloatingLabel label={t("changePasswordModal.confirmPasswordLabel")}>
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={data.confirmPassword}
                onChange={onChange}
                required
                placeholder=""
                minLength={6}
                isInvalid={validated && data.password !== data.confirmPassword}
              />
              <Form.Control.Feedback type="invalid">
                {data.password !== data.confirmPassword
                  ? t("changePasswordModal.passwordsDoNotMatch")
                  : t("changePasswordModal.confirmPasswordInvalid")}
              </Form.Control.Feedback>
            </FloatingLabel>

            <ShowPasswordButton onClick={onToggleConfirmPassword}>
              {showConfirmPassword ? <EyeSlash /> : <Eye />}
            </ShowPasswordButton>
          </InputGroup>

          <div className="d-flex justify-content-around align-items-cente buttonsContainer">
            <GreenLabel onClick={close} margin="0">
              {t("changePasswordModal.cancel")}
            </GreenLabel>

            <ActionButton width="35%" type="submit">
              {t("changePasswordModal.confirm")}
            </ActionButton>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePasswordModal;
